import { all, fork } from 'redux-saga/effects';
import auth from './auth/sagas';
import intakeForm from './intakeForm/sagas';
import leads from './leads/sagas';
import lead from './lead/sagas';
import gmaps from './gmaps/sagas';
import invites from './invites/sagas';
import proposals from './proposals/sagas';
import resources from './resources/sagas';
import agreements from './agreements/sagas';
import bulkEnrichment from './bulkEnrichment/sagas';
import prospectNowBulkEnrichment from './prospectNowBulkEnrichment/sagas';
import quotes from './quotes/sagas';

export default function* rootSaga() {
  yield all(
    [
      auth,
      intakeForm,
      leads,
      lead,
      gmaps,
      invites,
      proposals,
      resources,
      agreements,
      bulkEnrichment,
      prospectNowBulkEnrichment,
      quotes,
    ].map((task) => fork(task))
  );
}
